import React, { Component, Fragment } from 'react'
import style from '../Stepper/stepper.style'
import cx from 'classnames'

// COMPONENTS
import Spinner from '../../spinner/Spinner'
import { ButtonOutlined } from '../../app-button/button'
import { CheckSuccessIcon, AccountAlertIcon } from '../../app-icon/Icons'

class EcomPixel extends Component {
  state = {
    isError: false,
    isFetching: false,
    isReady: this.props.finish,
    isSetupEcom: window.state.ecom_setup_is_confirmed,
    errorsEcom: window.state.errorsEcom,
  }

  setup = status => {
    if (!status) {
      this.setState({
        isError: true,
      })
    }

    if (status) {
      this.setState({
        isReady: true,
      })

      if (this.state.errorsEcom && this.state.errorsEcom.length > 0) {
        location.reload()
      }
    }
    this.props.updateData(this.state.isReady, false)

    this.setState({
      isFetching: false,
    })
  }

  handleSetup = () => {
    this.setState({
      isFetching: true,
    })

    const url = '/ecom/enabled-pixel'

    const json = response => {
      return response.json()
    }

    const status = response => {
      if (response.status >= 200 && response.status < 300) {
        return Promise.resolve(response)
      } else {
        return Promise.reject(new Error(response.statusText))
      }
    }

    fetch(url, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute('content'),
      },
    })
      .then(status)
      .then(json)
      .then(({ status }) => {
        this.timerId = setTimeout(() => this.setup(status), 500)
      })
      .catch(function(error) {
        console.log('Request failed', error)
      })
  }

  componentWillUnmount() {
    clearTimeout(this.timerId)
  }

  render() {
    const { isFetching, isError, isReady } = this.state
    const { code, classes, site, errorsEcom } = this.props

    const error = isError ? (
      <div className={classes.error}>
        Код счетчика не найден на страницах сайта.
      </div>
    ) : null

    const icon = isReady ? (
      <CheckSuccessIcon />
    ) : (
      <span
        style={{
          width: 6,
          height: 6,
          border: 'solid 1px rgba(136, 102, 255, 0.2)',
          display: 'block',
          borderRadius: '100%',
        }}
      />
    )

    const content = isReady ? (
      <div
        style={{
          fontSize: 16,
          fontWeight: 'bold',
          lineHeight: 1.5,
          color: 'rgb(136, 102, 255)',
        }}
      >
        Готово!
      </div>
    ) : (
      <Fragment>
        <div
          style={{
            maxWidth: 588,
            border: 'solid 1px #979797',
            backgroundColor: '#d8d8d8',
            padding: '10px 20px',
            fontSize: '12px',
          }}
        >
          {code}
        </div>
        <ol
          style={{
            maxWidth: 670,
            padding: '0 0 0 15px',
            margin: '24px 0 24px 0',
            fontSize: 12,
            color: 'rgb(0, 0, 0, .75)',
          }}
        >
          <li>Скопируйте код счетчика из поля</li>
          <li>
            {`Добавьте скопированный код счетчика в HTML-код всех страниц
                  сайта. Код нужно разместить в пределах тегов <head />, как можно
                  ближе к началу страницы. Так он будет загружаться раньше, и
                  сможет отправить данные о просмотре, даже если посетитель быстро
                  закроет страницу, не дождавшись загрузки всех остальных скриптов
                  страницы.`}
          </li>
          <li>Нажмите кнопку “Код установлен!” для проверки</li>
        </ol>
        {error}
        <ButtonOutlined
          handleClick={this.handleSetup}
          style={{
            width: 200,
            height: 40,
            padding: 0,
          }}
          color="secondary"
          text={isFetching ? <Spinner stroke={'#8866ff'} /> : 'Код установлен!'}
        />
      </Fragment>
    )

    return (
      <div className={classes.step}>
        {isReady ? null : (
          <div
            style={{ display: 'flex', alignItems: 'center', marginBottom: 24 }}
          >
            <AccountAlertIcon />
            <span className={classes.errorMessage}>
              Код счетчика не найден на страницах сайта.
            </span>
          </div>
        )}
        <div className={classes.label}>
          {errorsEcom && errorsEcom.length > 0 ? null : (
            <span
              className={cx(classes.icon, {
                [classes.iconActive]: isReady,
              })}
            >
              {icon}
            </span>
          )}

          <span className={classes.title}>
            Установите специальный код на всех страницах вашего сайта {site}:
          </span>
        </div>
        <div
          className={cx(classes.content, {
            [classes.contentActive]: isReady,
            [classes.contentError]: errorsEcom && errorsEcom.length > 0,
          })}
        >
          {content}
        </div>
      </div>
    )
  }
}

export default style(EcomPixel)
